import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
} from "@mui/material";
import AppConstants from "../../../../AppConstants";

const BusinessDetForm = ({ open, onClose, isEdit, businessData, onSubmit }) => {
  const [businessName, setBusinessName] = useState("");
  const [description, setDescription] = useState("");
  const [place, setPlace] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [errors, setErrors] = useState({});

  const bID = localStorage.getItem(AppConstants.business_id);

  useEffect(() => {
    if (isEdit && businessData) {
      setBusinessName(businessData.business_title || "");
      setDescription(businessData.description || "");
      setPlace(businessData.place || "");
      setMobileNumber(businessData.mobile_number || "");
    } else {
      setBusinessName("");
      setDescription("");
      setPlace("");
      setMobileNumber("");
    }
  }, [isEdit, businessData]);

  const validate = () => {
    const formErrors = {};
    if (!businessName) formErrors.businessName = "Business Name is required";
    if (!place) formErrors.place = "Place is required";
    if (!mobileNumber) {
      formErrors.mobileNumber = "Mobile Number is required";
    } else if (!/^\d{10}$/.test(mobileNumber)) {
      formErrors.mobileNumber = "Mobile Number must be 10 digits";
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    const updatedData = {
      business: bID,
      business_title: businessName,
      description,
      place,
      mobile_number: mobileNumber,
    };
    onSubmit(updatedData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle style={{ color: "#ff4d4d" }}>{isEdit ? "Edit Franchisee Details" : "Add Franchisee Details"}</DialogTitle>
      <DialogContent>
        <TextField
          label="Franchisee Name"
          fullWidth
          margin="dense"
          value={businessName}
          onChange={(e) => {
            setBusinessName(e.target.value);
            if (errors.businessName) setErrors((prev) => ({ ...prev, businessName: "" }));
          }}
          error={!!errors.businessName}
          helperText={errors.businessName}
        />
        <TextField
          label="Place"
          fullWidth
          margin="dense"
          value={place}
          onChange={(e) => {
            setPlace(e.target.value);
            if (errors.place) setErrors((prev) => ({ ...prev, place: "" }));
          }}
          error={!!errors.place}
          helperText={errors.place}
        />
        <TextField
          label="Mobile Number"
          fullWidth
          margin="dense"
          value={mobileNumber}
          onChange={(e) => {
            setMobileNumber(e.target.value);
            if (errors.mobileNumber) setErrors((prev) => ({ ...prev, mobileNumber: "" }));
          }}
          error={!!errors.mobileNumber}
          helperText={errors.mobileNumber}
        />
        <TextField
          label="Description"
          fullWidth
          margin="dense"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          rows={4}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="error" style={{ textTransform: "none" }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="success" style={{ textTransform: "none" }}>
          {isEdit ? "Update" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BusinessDetForm;
